module.exports = __webpack_public_path__ + "img/product17.0a991ec5.png";